<template>
  <div class="wrapper">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-home-app-container-detail">
      <div class="ccui-app-container">
        <div>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form ref="form" :model="formData">
                <el-form-item label="">
                  <el-input
                    placeholder="请输入标题"
                    v-model="formData.themeTitle"
                  ></el-input>
                </el-form-item>
                <el-form-item label="" class="editor-content">
                  <editor
                    ref="editor"
                    :editorContent="editorContent"
                    @change="changeEditor"
                    :type="$route.query.type"
                    :pageSource="'postingAdd'"
                  ></editor>
                </el-form-item>
                <!-- <el-divider></el-divider> -->
                <el-form-item class="on-submit">
                  <el-button
                    type="primary"
                    @click="onSubmit"
                    style="width: 85px;"
                    >发 表</el-button
                  >
                </el-form-item>
                <el-form-item> </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="24">
        <el-col :span="18">
          <div class="my-upload">
            <el-upload
              multiple
              ref="upload"
              action=""
              accept=".pdf"
              :before-remove="handleBeforeRemove"
              :file-list="fileList"></el-upload>
          </div>
        </el-col>
      </el-row> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import editor from "@/app/shop/components/editor.vue";
import { saveThemeDetail } from "@/app/shop/api/shopping";
export default {
  name: "postingAdd",
  components: {
    baseBreadCrumb,
    editor
  },
  props: {
    source: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      currBreadCrumb: [
        { title: this.$route.query.type == "Edit" ? "编辑主题" : "新增主题" }
      ],
      formData: {
        themeTitle: ""
      },
      editorContent: ""
    };
  },
  mounted() {},
  activated() {
    if (this.$route.query.type && this.$route.query.type == "Edit") {
      this.formData.themeTitle = this.$route.query.title;
      this.$refs.editor.content = this.$route.query.editorContent;
      console.log(this.$route.query, this.$refs.editor, "editor");
    } else {
      this.formData.themeTitle = "";
      this.editorContent = "";
      this.$refs.editor.fileData = [];
    }
  },
  deactivated() {},
  methods: {
    selectChanged() {},
    onSubmit() {
      console.log(this.$refs.editor, "editor");
      if (this.formData.themeTitle == "") {
        this.$message({
          showClose: true,
          message: "请输入标题！",
          type: "error"
        });
      } else if (this.editorContent == "") {
        this.$message({
          showClose: true,
          message: "请输入主题内容！",
          type: "error"
        });
      } else {
        let params = {
          tbasFileInfoBOList: this.$refs.editor.fileData,
          themeId: this.$route.query.themeId,
          themeName: this.formData.themeTitle,
          content: this.editorContent,
          columnId: this.$route.query.columnId,
          isShowLoading: true
        };
        saveThemeDetail(params).then(res => {
          if (res.data.code == "0") {
            this.$message({
              showClose: true,
              message: "主题发表成功！",
              type: "success"
            });
            this.formData.themeTitle = "";
            this.$refs.editor.content = "";
            this.$refs.editor.fileData = [];
          }
        });
      }
    },
    changeEditor(val) {
      this.editorContent = val;
      console.log(this.editorContent, "changeEditor111");
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-input__inner {
  border: none !important;
  border-bottom: 1px solid #e8e8e8 !important;
  height: 80px;
  font-size: 16px;
  color: #4a4a4a;
}
::v-deep .el-divider--horizontal {
  margin: 20px 0 16px 78px !important;
  width: 93% !important;
}
/deep/ .el-input {
  width: 100% !important;
}
.ccui-app-container {
  min-height: 593px;
  padding: 20px !important;
  .posting-title {
    width: 300px;
  }
  .posting-content {
    margin-bottom: 20px;
  }
  .posting-enclosure {
    .upload-demo {
      text-align: right;
      margin-bottom: 20px;
    }
  }
  .posting-btn {
    text-align: center;
    margin-top: 20px;
    /deep/ .el-button--primary {
      width: 85px !important;
    }
  }
}
.editor-content {
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 29px;
}
.on-submit {
  text-align: right;
}
</style>
